globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.TransferFaqToLocation = (function(superClass) {

  utils.extend(TransferFaqToLocation, superClass);

  function TransferFaqToLocation() {
    return TransferFaqToLocation.__super__.constructor.apply(this, arguments);
  }

  $.extend(TransferFaqToLocation.prototype, {
    callbackSuccess: function(data, successMsg) {
      if (data == null) {
        data = {};
      }
      if (data.response) {
        window.location = data.redirect_url;
      }
    }
  });

  return TransferFaqToLocation;

})(appCustomerSpace.Modal);
